const STORE_INVITE_TOKEN_KEY = "fastsell_store_invite_token";

export function persistStoreInviteToken(token: string | null | undefined): void {
    if (!token || !token.trim()) return;
    try {
        localStorage.setItem(STORE_INVITE_TOKEN_KEY, token.trim());
    } catch {
        /* private mode / quota */
    }
}

export function readStoreInviteToken(): string | null {
    try {
        const v = localStorage.getItem(STORE_INVITE_TOKEN_KEY);
        return v && v.trim() ? v.trim() : null;
    } catch {
        return null;
    }
}

export function clearStoreInviteToken(): void {
    try {
        localStorage.removeItem(STORE_INVITE_TOKEN_KEY);
    } catch {
        /* ignore */
    }
}

/** Extrait `token` depuis un chemin type `/accept-invite?token=…` (param `redirect` login/signup). */
export function tryExtractInviteTokenFromRedirectParam(redirect: string | null | undefined): string | null {
    if (!redirect?.trim()) return null;
    try {
        const base = typeof window !== "undefined" ? window.location.origin : "https://usefastsell.com";
        const u = new URL(redirect, base);
        if (!u.pathname.endsWith("/accept-invite")) return null;
        const tok = u.searchParams.get("token");
        return tok && tok.trim() ? tok.trim() : null;
    } catch {
        return null;
    }
}
